<template>
    <div class="box tabbed">
        <h2>Rollen verwalten</h2>
        <ul class="tabs">
            <li :class="{ active: 'first' == activeTab }" @click="activeTab = 'first'">
                <i class="fal fa-user-shield"></i>
                Rollen
            </li>
            <li :class="{ active: 'second' == activeTab }" @click="activeTab = 'second'">
                <i class="fal fa-user-tag"></i>
                Zuordnung
            </li>
        </ul>
        <div class="body">
            <div :class="{ active: 'first' == activeTab }" class="master-detail" data-tab-content>
                <div class="master">
                    <ul>
                        <li v-for="role in roles" :class="{ active: role === selected }" v-bind:key="role.id" @click="selected = role">
                            <span class="title">{{ role.name }}</span>
                            <span class="toolbar">
                                <i @click="editRole(role)" class="edit fal fa-pencil"></i>
                                <i @click="deleteRole(role)" class="delete fal fa-trash-alt"></i>
                            </span>
                        </li>
                    </ul>
                    <button type="button" class="btn add" @click="addRole()"><i class="fal fa-plus"></i> Hinzufügen</button>
                </div>
                <div class="detail" v-if="selected">
                    <table class="perms">
                        <tbody v-for="(group, groupIdx) in firstRole.permissionGroups" v-bind:key="groupIdx">
                            <tr @click="toggleOpen(group.identifier)">
                                <td class="group-header" :class="{ open: groupOpen(group.identifier) }" :colspan="roles.length + 2">{{ group.label }}</td>
                            </tr>
                            <tr v-show="groupOpen(group.identifier)" v-for="(permission, permissionIdx) in group.permissions" v-bind:key="groupIdx + '_' + permissionIdx">
                                <td>{{ permission.label }}</td>
                                <td>
                                    <input v-model="selected.permissionGroups[groupIdx].permissions[permissionIdx].active" type="checkbox" :id="groupIdx + '_' + permissionIdx" /><label
                                        :for="groupIdx + '_' + permissionIdx"
                                    ></label>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="button-row" style="padding: 1.5rem; margin-top: 2rem;">
                        <button type="button" @click="saveRoles()" class="primary size-l"><i class="fal fa-save"></i> Speichern</button>
                    </div>
                </div>
                <div class="detail" style="padding: 1.5rem;" v-if="!selected">
                    <div class="info-box">
                        Wählen Sie zunächst eine Rolle
                    </div>
                </div>
            </div>

            <div :class="{ active: 'second' == activeTab }" data-tab-content>
                <table>
                    <tbody v-for="(assignGroup, idx) in roleAssignments" v-bind:key="idx">
                        <tr v-for="assignment in assignGroup.assignments" v-bind:key="assignment.id">
                            <td>{{ assignment.label }}</td>
                            <td>
                                <div class="form-group form-float form-select no-error">
                                    <select placeholder=" " v-model="assignment.role" :id="'assignrole_' + assignment.id">
                                        <option value=""></option>
                                        <option v-for="role in roles" v-bind:key="role.id" v-bind:value="role.id">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <label :for="'assignrole_' + assignment.id">Rolle</label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr />

                <div class="button-row">
                    <button @click="saveAssignments()" type="button" class="primary size-l"><i class="fal fa-save"></i> Speichern</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
div.internal main div.box.tabbed [data-tab-content].master-detail.active {
    display: flex;
    margin: -1.5rem;
}

div.master {
    border-right: 1px solid #e5ebec;

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    li {
        cursor: pointer;
        max-width: 200px;
        padding: 1rem;
        border-bottom: 1px solid #e5ebec;

        &:hover {
            background-color: #f7fafc;
        }

        span {
            display: block;
        }

        span.toolbar {
            margin-top: 0.5rem;
            text-align: right;
            i {
                margin-left: 1rem;
            }
        }

        &.active {
            background-color: darken(#f7fafc, 10);
        }
    }
}

div.detail {
    flex-grow: 1;
    overflow-x: auto;
}

table.perms {
    td:not(:first-child) {
        text-align: center;
    }
}
</style>

<script>
export default {
    data() {
        return {
            openGroups: {},
            activeTab: "first",
            roles: [],
            roleAssignments: [],
            selected: null
        };
    },
    created() {
        this.fetchData();
    },
    computed: {
        firstRole() {
            if (!this.roles || this.roles.length === 0) {
                return {};
            }

            return this.roles[0];
        }
    },
    methods: {
        fetchData() {
            this.$api.get("/roles").then(
                response => {
                    this.roles = response.data.data;
                },
                () => {
                    this.$snotify.error("Fehler beim Laden der Rollen");
                }
            );

            this.$api.get("/roles/assignments").then(
                response => {
                    this.roleAssignments = response.data.data;
                },
                () => {
                    this.$snotify.error("Fehler beim Laden der Rollenzuordnungen");
                }
            );
        },
        saveRoleFn(role) {
            return toast => {
                this.$api.put("/roles/role/" + role.id, { name: toast.value }).then(
                    () => {
                        role.name = toast.value;
                        this.$snotify.remove(toast.id);
                        this.$snotify.success("Role updated");
                    },
                    () => {
                        this.$snotify.error("Save failed");
                    }
                );
            };
        },
        createRoleFn(role) {
            return toast => {
                this.$api.post("/roles/role", { name: toast.value }).then(
                    response => {
                        role.name = toast.value;
                        role.id = response.data.data.id;
                        role.permissionGroups = [];
                        this.fetchData();
                        this.$snotify.remove(toast.id);
                        this.$snotify.success("Role created");
                    },
                    () => {
                        this.$snotify.error("Save failed");
                    }
                );
            };
        },
        noAction(toast) {
            this.$snotify.remove(toast.id);
        },
        deleteRole(role) {
            this.$snotify.confirm("Rolle dauerhaft löschen?", "Letzte Möglichkeit", {
                closeOnClick: false,
                position: "centerCenter",
                buttons: [
                    {
                        text: "Ja",
                        action: toast => {
                            this.performDelete(role);
                            this.$snotify.remove(toast.id);
                        }
                    },
                    {
                        text: "Nein"
                    }
                ]
            });
        },
        performDelete(role) {
            this.$api.delete("/roles/role/" + role.id).then(
                () => {
                    var idx = this.roles.indexOf(role);
                    this.roles.splice(idx, 1);
                    this.$snotify.success("Role deleted");
                    this.selected = null;
                },
                () => {
                    // Login failed
                    this.$snotify.error("Delete failed");
                }
            );
        },
        editRole(role) {
            this.$snotify.prompt("", "Edit Role", {
                buttons: [
                    { text: "Save", action: this.saveRoleFn(role), bold: true },
                    { text: "Cancel", action: this.noAction }
                ],
                placeholder: "Role name",
                position: "centerCenter"
            });
        },
        addRole() {
            var role = {};
            this.$snotify.prompt("", "Add Role", {
                buttons: [
                    { text: "Save", action: this.createRoleFn(role), bold: true },
                    { text: "Cancel", action: this.noAction }
                ],
                placeholder: "Role name",
                position: "centerCenter"
            });
        },
        saveAssignments() {
            var assigns = [];
            for (var i = 0; i < this.roleAssignments.length; i++) {
                for (var z = 0; z < this.roleAssignments[i].assignments.length; z++) {
                    assigns.push({
                        id: this.roleAssignments[i].assignments[z].id,
                        role: this.roleAssignments[i].assignments[z].role
                    });
                }
            }

            this.$api.post("/roles/assignments", assigns).then(
                () => {
                    this.$snotify.success("Assignments saved");
                },
                () => {
                    this.$snotify.error("Save failed");
                }
            );
        },
        saveRoles() {
            var perms = [];
            for (var g = 0; g < this.selected.permissionGroups.length; g++) {
                for (var p = 0; p < this.selected.permissionGroups[g].permissions.length; p++) {
                    perms.push({
                        role: this.selected.id,
                        identifier: this.selected.permissionGroups[g].permissions[p].identifier,
                        active: this.selected.permissionGroups[g].permissions[p].active
                    });
                }
            }

            this.$api.post("/roles/permissions", perms).then(
                () => {
                    this.$snotify.success("Permissions saved");
                },
                () => {
                    this.$snotify.error("Save failed");
                }
            );
        },
        groupOpen(obj) {
            if (typeof this.openGroups[obj] === "undefined") {
                this.$set(this.openGroups, obj, false);
                this.openGroups[obj] = false;
            }

            return this.openGroups[obj];
        },
        toggleOpen(obj) {
            this.$set(this.openGroups, obj, !this.openGroups[obj]);
        }
    }
};
</script>
